<template>
  <div style="background-color: #fafafa;">
    <div class="searchBox">
      <van-search class="search-box" background="#2D7FC7" shape="round" v-model="value" placeholder="搜索单号" show-action @search="onSearch" @input="onSearch"
                  @cancel="onSearch" @clear="onSearch">
        <div style="padding-top: 10px;" slot="action" @click="showFilterPop()"><van-icon name="filter-o" size="20"  color="#fafafa"/></div>
      </van-search>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
        <div style="width: 100%;" v-for="(item) in list" class="card" :key="item.uuid" @click="openForm(item.uuid)">
          <table class="layout" style="width: 100%;" >
            <tr style="width: 100%;">
              <td style="width: 60%;">
                <div class="header">
                  <span class="title">{{item.serialNumber}}</span>
                </div>
              </td>
              <td style="width: 40%;text-align: left;">
                <div style="width: 100%;display: inline-block; position: relative;">
                  <span style="color: red;font-weight: bold;">{{item.statusname}}</span>
                </div>
              </td>
            </tr>
            <tr style="width: 100%;">
              <td colspan="2" class="content" style="width: 100%;">
                <p><span>车间：</span><span>{{item.workshopIdname}}</span></p>
                <p><span>工序：</span><span>{{item.procedureIdname}}</span></p>
              </td>
            </tr>
            <tr style="width: 100%;">
              <td class="content" style="width: 50%;">
                <p><span>检验内容：</span><span>{{item.inspectionContentname}}</span></p>
                <p><span>检验数量：</span><span>{{item.quantity}}</span></p>
                <p><span>员工：</span><span>{{item.staffIdname}}</span></p>
              </td>
              <td class="content" style="width: 50%;">
                <p><span>检验方式：</span><span>{{item.inspectionMethodname}}</span></p>
                <p><span>合格数量：</span><span>{{item.passQuantity}}</span></p>
                <p><span>合格率(%)：</span><span>{{item.passRate}}</span></p>
              </td>
            </tr>
            <tr style="width: 100%;">
              <td colspan="2" class="content" style="width: 100%;">
                <p><span>创建时间：</span><span>{{item.createTime}}</span></p>
              </td>
            </tr>
          </table>
        </div>
        <div class="recordBox">
          <div
              style="display: flex;justify-content: space-between;align-items: center;"
          >
            <van-button
                style="height:30px;font-size: 14px;"
                type="info"
                size="large"
                @click="openForm('0')"
            >新建品质检验单</van-button
            >
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="showFilter" closeable position="bottom" :style="{ height: '80%' }"
               :close-on-click-overlay="false">
      <van-nav-bar title="申请时间" left-text="取消" right-text="确定"
                   @click-left="onFilterClickLeft()" @click-right="onFilterClickRight()" />
      <table class="layout">
        <tr>
          <td>
            <van-field-date v-model="startTime" type="date" format="yyyy-MM-dd" label="开始日期"></van-field-date>
            <van-field-date v-model="endTime" format="yyyy-MM-dd" type="date" label="结束日期"></van-field-date>
          </td>
        </tr>
      </table>
    </van-popup>
  </div>
</template>

<script>
import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Icon} from 'vant';
import qualityInspectionService from "../../service/qualityInspectionService";
import VanFieldDate from "../../components/VantFieldDate";
import {formatDictionary} from "../../utils/dictionary";
import moment from "moment";
export default {
  data: function () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      value: '',
      showFilter: false,
      startTime: "",
      endTime: "",
    }
  },

  components: {
    VanFieldDate,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
  },
  computed:{
    userId() {
      return this.$store.getters.getUserId;
    }
  },
  methods: {
    async onLoad() {
      this.pageIndex++;
      let resp = await qualityInspectionService.getQualityInspectionList(this.pageIndex, this.value, this.startTime, this.endTime);
      resp.data.Data.data.forEach(item => {
        item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
      });
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onSearch() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    showFilterPop(){
      this.showFilter = true;
    },
    onFilterClickLeft(){
      this.showFilter = false;
    },
    onFilterClickRight(){
      this.showFilter = false;
      this.onSearch();
    },
    openForm(uuid) {
      window.open('/wf/form/vsheet/form?workflowTemplateId=18a33c50c7c24d2594d478c62b19f4ac&id='+uuid);
    },
  }
};

</script>
<style>
.card p {
  margin:10px 0;
}
.card p>span:first-child {
  flex: 0 0 4rem;
  text-align: right;
  margin-right: 20px;
}
.van-pull-refresh__head{
  display: none;
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom:0;
  position:fixed;
  width: 100%;
}
.psiConfirmCont{
  width:100%;
  margin:0 auto;
  overflow: hidden;

}
.searchBox {
  height: 3rem;
  box-sizing: border-box;
  margin-bottom: 2rem;
  top: 0;
  position:fixed;
  width: 100%;
  background-color: #2D7FC7;
  z-index:999;
}
</style>